'use es6';

import { userInfoSync } from 'hub-http/userInfo';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import UIButton from 'UIComponents/button/UIButton';
import { DefaultFieldKeys } from 'ExportDialog/Constants';
import ExportDialog from 'ExportDialog/modal/ExportDialog';
import createFormField from 'ExportDialog/modal/formFields/FormField';
import { growl } from 'EmailComponents/errors/growl';
import makeReadOnlyEmailField from 'EmailComponents/utils/makeReadOnlyEmailField';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExportClient = doExport => ({
  export(data) {
    return doExport(data);
  }
});
const AnalyzeExportDescription = () => /*#__PURE__*/_jsx(View, {
  marginBlockEnd: "500",
  as: "div",
  children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "EmailComponents.header.exportDescription"
  })
});
const DashboardListingExportDescription = () => () => /*#__PURE__*/_jsx(View, {
  marginBlockEnd: "500",
  as: "div",
  children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "EmailComponents.header.exportSpreadsheetDescription"
  })
});
export default class ChartsExportButton extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isOpen: false
    };
    this.openModal = () => {
      this.setState({
        isOpen: true
      });
    };
    this.closeModal = () => {
      this.setState({
        isOpen: false
      });
    };
  }
  showSuccessMessage() {
    this.props.track();
    growl('success', I18n.text('EmailComponents.export.success_message'));
  }
  render() {
    const {
      isOpen
    } = this.state;
    const userEmail = userInfoSync().user.email;
    const exportClient = ExportClient(this.props.doExport);
    const formFields = [AnalyzeExportDescription, DashboardListingExportDescription(), createFormField(makeReadOnlyEmailField(userEmail), DefaultFieldKeys.EMAIL)];
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UIButton, {
        onClick: this.openModal,
        size: this.props.styleType.size,
        style: this.props.style,
        use: this.props.styleType.use,
        children: I18n.text('EmailComponents.header.exportButton')
      }), isOpen ? /*#__PURE__*/_jsx(ExportDialog, {
        client: exportClient,
        formFields: formFields,
        headerContents: I18n.text('EmailComponents.header.exportButton'),
        onClose: this.closeModal,
        onFailure: emptyFunction,
        onSuccess: () => this.showSuccessMessage(),
        userEmail: userEmail
      }) : null]
    });
  }
}
ChartsExportButton.propTypes = {
  doExport: PropTypes.func.isRequired,
  style: PropTypes.object,
  styleType: PropTypes.shape({
    use: PropTypes.string,
    size: PropTypes.string
  }),
  track: PropTypes.func
};
ChartsExportButton.defaultProps = {
  style: {},
  styleType: {
    use: 'secondary',
    size: 'default'
  },
  track: emptyFunction
};